// import { TableColumnsType } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { ApplicationSummary } from '../../../../shared/VolunteerApplicationServiceTypes';
import { useTranslation } from 'react-i18next';
import {
	displayTranslatedPreworkStatus,
	getFullName,
} from '../../../../shared/Utils';
import { CalendarOutlined } from '@ant-design/icons';
import { utc } from 'moment';
import { DATE_DD_MM_YYYY } from '../../../../shared/Constants';
import { useApplicationStatusTranslation } from '../../../../hooks/useApplicationStatusTranslation';

export const ElgibleCandidatesTableColumns =
	(): ColumnsType<ApplicationSummary> => {
		const { t } = useTranslation();
		const { getTranslatedValue } = useApplicationStatusTranslation();

		return [
			{
				title: t('name'),
				dataIndex: 'name',
				key: 'name',
				width: 200,
				render: (__, record) => getFullName(record.applicant),
			},
			{
				title: t('batchName'),
				dataIndex: 'batch.name',
				key: 'batch.name',
				render: (__, record) => <span>{record.batch?.name}</span>,
			},
			{
				title: t('SRCMID'),
				dataIndex: 'srcmId',
				key: 'srcmId',
				render: (__, record) => <span>{record.applicant.srcmid}</span>,
			},
			{
				title: t('zone'),
				dataIndex: 'zone',
				key: 'zone',
				render: (__, record) => <span>{record.center.zone}</span>,
			},
			{
				title: t('region'),
				dataIndex: 'region',
				key: 'region',
				width: 200,
				render: (__, record) => <span>{record.center.region}</span>,
			},
			{
				title: t('status'),
				dataIndex: 'applicationStatus',
				key: 'applicationStatus',
				width: 200,
				render: (__, record) => (
					<span>{getTranslatedValue(record.applicationStatus, true)}</span>
				),
			},
			{
				title: t('waitingPeriod'),
				dataIndex: 'canReapplyDate',
				key: 'canReapplyDate',
				render: (_, record) => {
					const canReapplyDate =
						record?.applicationPreworkStatus?.canReapplyDate ||
						record?.canReapplyDate;

					return (
						<span className="flex items-center whitespace-nowrap">
							{canReapplyDate ? (
								<>
									<CalendarOutlined />
									<span className="ml-2">
										{utc(canReapplyDate).format(DATE_DD_MM_YYYY)}
									</span>
								</>
							) : (
								'-'
							)}
						</span>
					);
				},
			},
			{
				title: t('prework'),
				dataIndex: 'applicationPreworkStatus.preworkStatus',
				key: 'applicationPreworkStatus.preworkStatus',
				render: (__, record) => (
					<span>
						{t(
							displayTranslatedPreworkStatus(
								record.applicationPreworkStatus?.preworkStatus
							)
						)}
					</span>
				),
			},
			{
				title: t('examCount'),
				dataIndex: 'noOfExamsRegistered',
				key: 'noOfExamsRegistered',
				render: (__, record) => <span>{record.noOfExamsRegistered || 0}</span>,
			},
		];
	};
